/**
 * Remembered UI choices.
 *
 * Reads are validated against the allowed set rather than cast, so a stale or
 * hand-edited value falls back to the derived default instead of putting the
 * list into a state the code no longer renders.
 */
export function readPref<T extends string>(key: string, allowed: readonly T[]): T | null {
  try {
    const raw = localStorage.getItem(key);
    return allowed.find((value) => value === raw) ?? null;
  } catch {
    // Safari with cookies blocked throws on localStorage rather than returning
    // null, and a lost preference must not take the page down.
    return null;
  }
}

export function writePref(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // See readPref.
  }
}
